import script from "./laundry-report.vue?vue&type=script&setup=true&lang=ts"
export * from "./laundry-report.vue?vue&type=script&setup=true&lang=ts"

import "./laundry-report.vue?vue&type=style&index=0&id=5feb0182&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5feb0182"]])

export default __exports__